import { useTranslation } from '@pancakeswap/localization'
import { ChainId } from '@pancakeswap/sdk'
import {
  Box,
  Flex,
  LogoutIcon,
  RefreshIcon,
  Text,
  useModal,
  UserMenu as UIKitUserMenu,
  UserMenuDivider,
  UserMenuItem,
  UserMenuVariant,
  useMatchBreakpoints,
} from '@pancakeswap/uikit'
import { CloseIcon } from '../../../../packages/uikit/src/components/Svg'

import ConnectWalletButton from 'components/ConnectWalletButton'
import Trans from 'components/Trans'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useAuth from 'hooks/useAuth'
import Image from 'next/image'
import NextLink from 'next/link'
import { useEffect, useState } from 'react'
import { usePendingTransactions } from 'state/transactions/hooks'
import { useAccount } from 'wagmi'
import WalletModal, { WalletView } from './WalletModal'
import WalletUserMenuItem from './WalletUserMenuItem'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { usePoolsContract } from 'hooks/useContract'
import { formatEther } from '@ethersproject/units'

const NavMobile = styled.div`
  .text:hover {
    background: #f8ebdc;
    color: #402d17;
  }
`
const TextLink = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  color: #ffffff;
`
const UserMenuNewDrider = styled.hr`
  border-color: rgba(255, 255, 255, 0.06);
  border-style: solid;
  border-width: 1px 0 0;
  margin: 4px 0;
`

const UserMenuV2 = ({ data }) => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const { chainId, isWrongNetwork } = useActiveChainId()
  const { logout } = useAuth()
  const { hasPendingTransactions, pendingNumber } = usePendingTransactions()
  const [onPresentWalletModal] = useModal(<WalletModal initialView={WalletView.WALLET_INFO} />)
  const [onPresentTransactionModal] = useModal(<WalletModal initialView={WalletView.TRANSACTIONS} />)
  const [onPresentWrongNetworkModal] = useModal(<WalletModal initialView={WalletView.WRONG_NETWORK} />)
  const [userMenuText, setUserMenuText] = useState<string>('')
  const [userMenuVariable, setUserMenuVariable] = useState<UserMenuVariant>('default')
  useEffect(() => {
    if (hasPendingTransactions) {
      setUserMenuText(t('%num% Pending', { num: pendingNumber }))
      setUserMenuVariable('pending')
    } else {
      setUserMenuText('')
      setUserMenuVariable('default')
    }
  }, [hasPendingTransactions, pendingNumber, t])

  const onClickWalletMenu = (): void => {
    if (isWrongNetwork) {
      onPresentWrongNetworkModal()
    } else {
      onPresentWalletModal()
    }
  }
  const { isMobile, isTablet } = useMatchBreakpoints()
  // const getCSTPrice = async () => {
  //   const CSTPRice = await getPoolsContract.CST2USDT()
  //   setPriceCST(Number(formatEther(CSTPRice)))
  // }
  // useEffect(() => {
  //   getCSTPrice()
  // }, [])
  const UserMenuItems = () => {
    return (
      <div style={{ padding: isMobile ? '32px 24px' : '16px', width: '305px' }}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          {/* <CloseIcon cursor="pointer" width="24px" color="white" /> */}
          <img style={{ cursor: 'pointer' }} width={24} height={24} src="/images/core/CloseIcon.png" />
        </div>
        {isMobile || isTablet ? (
          <>
            <NavMobile>
              {data.map((items, index) => (
                <>
                  <UserMenuItem className="text" key={index}>
                    <Link to={items.link}>
                      <TextLink className="text">{items.label}</TextLink>
                    </Link>
                  </UserMenuItem>
                </>
              ))}
            </NavMobile>
            <UserMenuNewDrider />
          </>
        ) : null}
        <WalletUserMenuItem isWrongNetwork={isWrongNetwork} onPresentWalletModal={onClickWalletMenu} />
        <UserMenuItem as="button" disabled={isWrongNetwork} onClick={onPresentTransactionModal}>
          <Flex alignItems="center" justifyContent="center" style={{ gap: '8px' }}>
            <Image src="/images/trans.png" width={15} height={15} alt="" />
            <Text style={{ color: '#FFFFFF', fontWeight: '700' }}> {t('Recent Transactions')}</Text>
          </Flex>
          {hasPendingTransactions && <RefreshIcon spin />}
        </UserMenuItem>
        <UserMenuItem>
          <NextLink href="/referral" passHref>
            <Flex alignItems="center" style={{ gap: '8px' }}>
              <Image src="/images/referral.png" width={15} height={15} alt="" />
              <Text style={{ color: '#FFFFFF', fontWeight: '700' }}> {t('Referral')}</Text>
            </Flex>
          </NextLink>
        </UserMenuItem>
        <UserMenuNewDrider />
        {/* <NextLink href={`/profile/${account?.toLowerCase()}`} passHref> */}
        {/*   <UserMenuItem as="a" disabled={isWrongNetwork || chainId !== ChainId.BSC}> */}
        {/*     {t('Your NFTs')} */}
        {/*   </UserMenuItem> */}
        {/* </NextLink> */}
        {/* <ProfileUserMenuItem */}
        {/*   isLoading={isLoading} */}
        {/*   hasProfile={hasProfile} */}
        {/*   disabled={isWrongNetwork || chainId !== ChainId.BSC} */}
        {/* /> */}
        <UserMenuItem as="button" onClick={logout}>
          <Flex alignItems="center" style={{ gap: '8px' }}>
            <Image src="/images/logout.png" width={15} height={15} alt="logout" />
            <Text style={{ color: '#FFFFFF', fontWeight: '700' }}> {t('Disconnect')}</Text>
          </Flex>
        </UserMenuItem>
      </div>
    )
  }

  if (account) {
    return (
      <UIKitUserMenu account={account} text={userMenuText} variant={userMenuVariable}>
        {({ isOpen }) => (isOpen ? <UserMenuItems /> : null)}
      </UIKitUserMenu>
    )
  }

  if (isWrongNetwork) {
    return (
      <UIKitUserMenu text={t('Network')} variant="danger">
        {({ isOpen }) => (isOpen ? <UserMenuItems /> : null)}
      </UIKitUserMenu>
    )
  }

  return (
    <>
      {/* <div>
      <Text style={{color: 'red', fontSize:'32px'}}>CST: {priceCST.toFixed(2)}</Text>
    </div> */}
      <ConnectWalletButton scale="sm">
        <Box
          display={['none', , , 'flex']}
          style={{
            alignItems: 'center',
            gap: '10px',
            fontSize: '20px',
            padding: '5px 8px',
            background: 'linear-gradient(180deg, rgba(1, 7, 13, 0.70) 0%, rgba(255, 148, 0, 0.11) 194.05%)',
            fontWeight: 500,
          }}
        >
          <Trans>Connect Wallet</Trans>
        </Box>
        <Box display={['block', , , 'none']}>
          <Trans>Connect</Trans>
        </Box>
      </ConnectWalletButton>
    </>
  )
}

export default UserMenuV2
